import { render } from "./UnitKategori.vue?vue&type=template&id=8cd1398e"
import script from "./UnitKategori.vue?vue&type=script&lang=js"
export * from "./UnitKategori.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__